<ul class="flex w-full justify-end" *ngIf="vm$ | async as vm">
	<li *ngFor="let tab of vm.tabs; index as index" class="flex -ml-6">
		<app-anchor
			[tooltip]="tab.description"
			[url]="tab.url"
			type="tab"
			[cssClasses]="['pr-10']"
			(onClick)="selectMortgage(index)"
		>
			<div class="space-x-3 flex flex-row align-middle items-center">
				<div class="h-4" *ngIf="tab?.logoUrl">
					<img
						class="h-full w-full"
						[src]="'/assets/images/banks/' + tab?.logoUrl"
					/>
				</div>
				<span>{{ tab.description }}</span>
			</div>
		</app-anchor>
		<app-button
			*ngIf="canDelete && deletingTab !== tab.id"
			iconClasses="text-green"
			[holdable]="true"
			size="small"
			btn="tertiary"
			[icon]="ICON.REMOVE"
			class="-left-6"
			(onClick)="remove(tab)"
		></app-button>
		<app-icon [icon]="" *ngIf="deletingTab === tab.id"></app-icon>
	</li>
</ul>
